import { connectorByIdQuery } from 'src/services/DOM/queries/connectorById/__generated__/connectorByIdQuery.graphql';
import { BuildUpdateScheduleStringReturn } from './model';
import { getTranslatedCronFrequencyWithoutTime } from 'src/products/connector/pages/connector-inventory/utils/translatedCronFrequency';

export const buildUpdateScheduleString = (
  sources: connectorByIdQuery['response']['connector']['sources']
): BuildUpdateScheduleStringReturn => {
  if (!sources.length) {
    return 'N/A';
  }

  return getTranslatedCronFrequencyWithoutTime(sources[0].schedule);
};
